export default __webpack_public_path__ + "static/media/casino_live_teenpatiplus.2970bc6a.png";